import type { QueryKeyFactory } from "app/pages/sales-intelligence/types/queries";

const ONBOARDING_INITIAL_INFO_QUERY_KEY = "onboarding-initial-info";
const ONBOARDING_SIGNALS_INFO_QUERY_KEY = "onboarding-signals-info";

interface OnboardingQueryKeyFactory extends QueryKeyFactory {
    onboardingInitData(): string[];
    onboardingSignalsInfoData(): string[];
}

export const onboardingQueryKeyFactory: OnboardingQueryKeyFactory = {
    onboardingInitData(): string[] {
        return [ONBOARDING_INITIAL_INFO_QUERY_KEY];
    },
    onboardingSignalsInfoData(): string[] {
        return [ONBOARDING_SIGNALS_INFO_QUERY_KEY];
    },
};
